/**
 * Campaign Find Care Javascript.
 */

/* global google */

;(function ($) {
	'use strict'

	$(document).ready(function () {
		$('.wp-block-ardent-health-theme-campaign-find-care').each(function () {
			const $block = $(this)
			const $mapEl = $block.find('.campaign-map')
			const blockId = $block.attr('id')

			if (!$mapEl.length) return

			const jsonData = $mapEl.data('locations')
			if (!jsonData || !jsonData.locations || !jsonData.locations.length) return

			const locations = jsonData.locations
			const mapColors = jsonData.mapSettings.colors || {}

			let map
			let markers = []
			let bounds
			let activeMarker = null

			async function initMap() {
				const { Map } = await google.maps.importLibrary('maps')
				const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary('marker')

				bounds = new window.google.maps.LatLngBounds()

				map = new Map($mapEl[0], {
					mapId: blockId + '_map',
					mapTypeControl: false,
					zoomControl: true,
					scaleControl: true,
					streetViewControl: false,
					fullscreenControl: false,
				})

				locations.forEach((location, index) => {
					if (!location.latitude || !location.longitude) return

					const pin = new PinElement()
					if (mapColors.primary) pin.background = mapColors.primary
					if (mapColors.secondary) pin.glyphColor = mapColors.secondary
					if (mapColors.border) pin.borderColor = mapColors.border

					const marker = new AdvancedMarkerElement({
						position: new window.google.maps.LatLng(location.latitude, location.longitude),
						map: map,
						content: pin.element,
						title: location.locationName,
					})

					marker.pin = pin // Store reference for state changes
					markers[index] = marker

					marker.addListener('click', () => selectLocation(index))

					bounds.extend(marker.position)
				})

				// Clicking a row selects that location on the map. Clicks on the inner
				// links (phone, More Info) are left to do their own thing.
				$block.on('click', '.location-list-item', function (e) {
					if ($(e.target).closest('a').length) return
					selectLocation(parseInt($(this).attr('data-location-index'), 10), true)
				})

				// Keyboard: Enter / Space on a focused row selects it.
				$block.on('keydown', '.location-list-item', function (e) {
					if ('Enter' === e.key || ' ' === e.key || 'Spacebar' === e.key) {
						if ($(e.target).closest('a').length) return
						e.preventDefault()
						selectLocation(parseInt($(this).attr('data-location-index'), 10), true)
					}
				})

				if (markers.length > 0) {
					map.fitBounds(bounds)

					// Adjust zoom once bounds are set
					const zoomChangeBoundsListener = window.google.maps.event.addListener(
						map,
						'bounds_changed',
						function () {
							if (this.getZoom() > 15) {
								this.setZoom(15)
							}
							window.google.maps.event.removeListener(zoomChangeBoundsListener)
						}
					)
				}
			}

			// Shared selection path for both map markers and list rows.
			function selectLocation(index, fromList) {
				const location = locations[index]
				const marker = markers[index]
				if (!location) return

				// Reset previously active marker color.
				if (activeMarker && activeMarker.pin) {
					if (mapColors.primary) activeMarker.pin.background = mapColors.primary
					if (mapColors.secondary) activeMarker.pin.glyphColor = mapColors.secondary
				}

				// Highlight the selected marker.
				if (marker && marker.pin) {
					marker.pin.background = mapColors.secondary || '#000000'
					marker.pin.glyphColor = mapColors.primary || '#ffffff'
					activeMarker = marker
				}

				// Two-way highlight: keep the list row in sync.
				$block.find('.location-list-item').removeClass('is-active').attr('aria-selected', 'false')
				$block
					.find('.location-list-item[data-location-index="' + index + '"]')
					.addClass('is-active')
					.attr('aria-selected', 'true')

				// Keep the selected row visible in the scrollable list (e.g. on pin click).
				scrollListToActive(index)

				// A list click pans the map to the pin; on mobile bring the map into view.
				if (fromList && marker && map) {
					map.panTo(marker.position)
					if (window.innerWidth < 768) {
						$mapEl[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' })
					}
				}
			}

			// Scroll the list container so the active row is in view (no page jump).
			function scrollListToActive(index) {
				const $list = $block.find('.location-list')
				const $item = $list.find('.location-list-item[data-location-index="' + index + '"]')
				if (!$list.length || !$item.length) return

				const list = $list[0]
				const item = $item[0]
				const itemTop = item.getBoundingClientRect().top - list.getBoundingClientRect().top + list.scrollTop
				const itemBottom = itemTop + item.offsetHeight

				if (itemTop < list.scrollTop) {
					list.scrollTo({ top: itemTop, behavior: 'smooth' })
				} else if (itemBottom > list.scrollTop + list.clientHeight) {
					list.scrollTo({ top: itemBottom - list.clientHeight, behavior: 'smooth' })
				}
			}

			// Helper to run initMap with error handling
			function runMap() {
				initMap().catch(function () {
					$mapEl.html(
						'<p style="padding: 2rem; text-align: center; background: #f5f5f5; border-radius: 8px; color: #555;">Map could not be loaded. Please try again later.</p>'
					)
				})
			}

			// Wait for Google Maps API to be ready before initializing
			if (typeof google !== 'undefined' && google.maps) {
				runMap()
			} else {
				// The inline script loads the API asynchronously. We can wait for it or just call initMap directly because it uses importLibrary
				runMap()
			}
		})
	})
})(jQuery)
